import moment from 'moment'

import { i18n } from '@/i18n'

const dateStringOptions = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
}

const dateUtils = {
  methods: {
    formattedDateTime(dateString) {
      return `${this.formattedDate(dateString)} ${this.formattedTime(dateString)}`
    },
    formattedDate(dateString) {
      if (!dateString) return '-'
      return new Date(dateString).toLocaleDateString('de', dateStringOptions)
    },
    formattedTime(dateString) {
      if (!dateString) return '-'
      return new Date(dateString).toLocaleTimeString('de')
    },
    formattedFromDateTime(datetime, format) {
      if (!datetime) return '-'

      const dateFormat = format || `DD.MM.YYYY, HH:mm [${this.$t('meta.oClock')}]`
      return moment(datetime).format(dateFormat)
    },
    olderThan24Hours(datetime) {
      const timeToCompare = moment(datetime)
      const now = moment(new Date())

      const differenceInHours = moment.duration(now.diff(timeToCompare)).asHours()

      return differenceInHours > 24
    },
    olderThan7Days(datetime) {
      if (!datetime) return true

      const timeToCompare = moment(datetime)
      const now = moment(new Date())
      const differenceInDays = moment.duration(now.diff(timeToCompare)).asDays()

      return differenceInDays > 7
    },
    sortBy({ items, property, ascending = true }) {
      if (ascending) {
        return items.sort((a, b) => new Date(a[property]) - new Date(b[property]))
      } else {
        return items.sort((a, b) => new Date(b[property]) - new Date(a[property]))
      }
    },
    weekday(date) {
      return new Date(date).toLocaleString(i18n.locale, { weekday: 'long' })
    },
  },
}

export default dateUtils
